import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import type { IncomingInvoiceUnpayableReason } from "@msuite/utils/types";

/** Props Interface */
interface PaymentReasonCellProps {
	reason: IncomingInvoiceUnpayableReason | null;
}

/** Why an invoice cannot be paid, or that it can. */
export function PaymentReasonCell({ reason }: PaymentReasonCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	if (!reason) {
		return (
			<Tag
				size="xs"
				color="emerald"
				variant="plain"
			>
				{t("incoming_invoices.payments.payable")}
			</Tag>
		);
	}
	return (
		<Tag
			size="xs"
			color="red"
			variant="plain"
		>
			{t(`incoming_invoices.payments.reasons.${reason}`)}
		</Tag>
	);
}
